<template>
  <div class="footer">
    <div class="footer-dir"></div>
    <div class="footer-bottom">
      <div class="contact-info">
        <div class="contact-title">联系方式</div>
        <div class="contact-text">联系人：中物鉴智（成都）科技成果评价有限公司</div>
        <div class="contact-text">联系地址：中国（四川）自由贸易试验区成都高新区天府五街200号菁蓉汇2号楼A区3层</div>
        <div class="contact-text">联系方式：400-136-5770, 028-81503300</div>
        <div class="filing-info" aria-label="备案信息">
          <img class="filing-police-icon" src="../assets/images/gongan.png" alt="公安标识" />
          <span class="filing-text">ICP备案号：蜀ICP备2024097865号-2 四川博创汇前沿科技有限公司</span>
        </div>
      </div>
      <div class="qrcode-group">
        <div class="qrcode-box">
          <img src="../assets/images/code.png" alt="二维码1" />
        </div>
        <div class="qrcode-box">
          <img src="../assets/images/codeTwo.jpg" alt="二维码2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  methods: {
    toPath(path) {
      if (this.$route.path == path) {
        return;
      }
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  background: #000f2c;
  padding-bottom: 60px; 
  padding-top: 20px; 
}

.footer-bottom {
  padding: 40px 6% 0; 
  display: flex;
  justify-content: space-between;
  align-items: flex-start; 
  gap: 30px; 
  flex-wrap: wrap; 
}
.contact-info {
  flex: 1; 
  min-width: 280px; 

  .contact-title {
    font-size: 24px;
    color: #fff;
    margin-bottom: 15px; 
  }

  .contact-text {
    color: #fff;
    font-size: 20px;
    line-height: 1.6; 
    margin-top: 10px;
    word-break: break-all; 
  }

  .filing-info {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 22px;
    color: rgba(255, 255, 255, 0.78);
    font-size: 16px;
    line-height: 1.6;

    .filing-police-icon {
      width: 20px;
      height: 20px;
      flex: 0 0 20px;
      display: block;
    }

    .filing-text {
      min-width: 0;
      word-break: break-all;
    }
  }
}
.qrcode-group {
  display: flex;
  align-items: center;
  gap: 20px; 
  flex-shrink: 0; 
  flex-wrap: wrap;
  justify-content: center; 
}
.qrcode-box {
  padding: 5px;
  background: #fff;
  border-radius: 4px; 

  img {
    width: 180px;
    height: 180px;
    display: block; 
  }
}
@media (max-width: 1024px) {
  .contact-info .contact-title {
    font-size: 22px;
  }

  .contact-info .contact-text {
    font-size: 18px;
  }

  .contact-info .filing-info {
    font-size: 15px;
  }

  .qrcode-box img {
    width: 150px;
    height: 150px;
  }
}
@media (max-width: 768px) {
  .footer-bottom {
    flex-direction: column;
    align-items: center; 
    text-align: center; 
    padding: 30px 4% 0; 
  }

  .contact-info .contact-title {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .contact-info .contact-text {
    font-size: 16px;
    line-height: 1.5;
  }

  .contact-info .filing-info {
    justify-content: center;
    margin-top: 18px;
    font-size: 14px;
    text-align: left;
  }

  .qrcode-group {
    margin-top: 20px; 
  }

  .qrcode-box img {
    width: 120px;
    height: 120px;
  }
}
@media (max-width: 480px) {
  .footer {
    padding-bottom: 40px;
  }

  .contact-info .contact-title {
    font-size: 18px;
  }

  .contact-info .contact-text {
    font-size: 14px;
  }

  .contact-info .filing-info {
    font-size: 13px;
  }

  .qrcode-box img {
    width: 100px;
    height: 100px;
  }

  .qrcode-group {
    gap: 15px;
  }
}
</style>
